import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]

import { useDarkMode } from '@theme/useDarkMode'
import { useThemeLocaleData } from '@theme/useThemeData'
import type { FunctionalComponent } from 'vue'
import { computed, h } from 'vue'
import {
  ClientOnly,
  RouteLink,
  useRouteLocale,
  useSiteLocaleData,
  withBase,
} from 'vuepress/client'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPNavbarBrand',
  setup(__props) {

const routeLocale = useRouteLocale()
const siteLocale = useSiteLocaleData()
const themeLocale = useThemeLocaleData()
const isDarkMode = useDarkMode()

const navbarBrandLink = computed(
  () => themeLocale.value.home || routeLocale.value,
)
const navbarBrandTitle = computed(() => siteLocale.value.title)
const navbarBrandLogo = computed(() => {
  if (isDarkMode.value && themeLocale.value.logoDark !== undefined) {
    return themeLocale.value.logoDark
  }
  return themeLocale.value.logo
})
const navbarBrandLogoAlt = computed(
  () => themeLocale.value.logoAlt ?? navbarBrandTitle.value,
)
const navBarLogoAltMatchesTitle = computed(
  () =>
    navbarBrandTitle.value.toLocaleUpperCase().trim() ===
    navbarBrandLogoAlt.value.toLocaleUpperCase().trim(),
)
const NavbarBrandLogo: FunctionalComponent = () => {
  if (!navbarBrandLogo.value) return null
  const img = h('img', {
    class: 'vp-site-logo',
    src: withBase(navbarBrandLogo.value),
    alt: navbarBrandLogoAlt.value,
  })
  if (themeLocale.value.logoDark === undefined) {
    return img
  }
  // wrap brand logo with <ClientOnly> to avoid ssr-mismatch
  // when using a different brand logo in dark mode
  return h(ClientOnly, () => img)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouteLink), { to: navbarBrandLink.value }, {
    default: _withCtx(() => [
      _createVNode(NavbarBrandLogo),
      (navbarBrandTitle.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["vp-site-name", { 'vp-hide-mobile': navbarBrandLogo.value }]),
            "aria-hidden": navBarLogoAltMatchesTitle.value
          }, _toDisplayString(navbarBrandTitle.value), 11, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})